export default __webpack_public_path__ + "static/media/bg-light-blue.d99f851d.png";